import { FirstPage } from "@mui/icons-material";
import React from "react";
import FirstVideo from "../components/Home/FirstVideo";
import FastestGrowing from "../components/Home/FastestGrowing";
import TailoredProducts from "../components/Home/TailoredProducts";
import { Box } from "@mui/material";
import RefineServices from "../components/Home/RefineServices";
import WhatSetAcross from "../components/Home/WhatSetAcross";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import Header from "../layout/Header";
import WhyAcrossAutoAssist from "../components/AutomobileAssistance/WhyAcrossAutoAssist";
import WhyPartnerWithAcross from "../components/BecomePartner/WhyPartnerWithAcross";
import WhyParthnerWithAcrossAssist from "../components/Home/WhyParthnerWithAcrossAssist";
import HomeAbout from "../components/Home/HomeAbout";
import WorkingProcess from "../components/Home/WorkingProcess";
import NewsLetter from "../components/Home/NewsLetter";
import InsuranceSection from "../components/Home/InsuranceSection";
import BlogsHomeSection from "../components/Home/BlogsHomeSection";

const Home = () => {
  return (
    <>
      <Header />

      <FirstVideo />
      <FastestGrowing />

      {/* <HomeAbout /> */}

      <TailoredProducts />

      <WhyParthnerWithAcrossAssist />
      {/* <Box
        sx={{
          textAlign: "center",
          py: 4,
        }}
      >
        <h4 style={{ textAlign: "center" }}>
          Redefine Customer Service with Across Assist
        </h4>
        <RefineServices />
      </Box> */}

      {/* <Box sx={{ backgroundColor: "#ffffff", py: 4 }}>
        <h4 className="main-heading-font-size" style={{ textAlign: "center" }}>
          What sets Across Assist apart?
        </h4>
        <WhatSetAcross />
      </Box> */}

      <InsuranceSection />

      {/* add new section  */}

      {/* <WorkingProcess /> */}

      <BlogsHomeSection />

      <NewsLetter />
    </>
  );
};

export default Home;
